import React, { Component } from 'react'
import { TryMap } from '../../components/index'
import { changeTipoFigura } from '../../libs/utils/GlobalFunc';

class CreateRoute extends Component {

    RefreshModel = (RouteDoc) => {
        const { RefreshRouteDoc } = this.props
        RefreshRouteDoc(RouteDoc);
    }

    //#region ######### ONCHANGE FIELDS MODEL ############################################################
    OnchangeRouteName = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.Name = value;
        this.RefreshModel(RouteDoc);
    }

    OnchangeRouteCode = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.Code = value;
        this.RefreshModel(RouteDoc);
    }

    OnchangeRouteDescription = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.Description = value;
        this.RefreshModel(RouteDoc);
    }

    OnchangeDriver = async (index) => {
        const { RouteDoc, Drivers } = this.props
        RouteDoc.IdVDRV = Drivers[index].CodigoFiguraTransporte;
        RouteDoc.NameDriver = Drivers[index].NombreFigura;
        RouteDoc.AuxIndexDriver = index;
        await this.RefreshModel(RouteDoc);
    }

    OnchangeVehicle = (value) => {
        const { RouteDoc } = this.props
        // RouteDoc.IdVHCL = value;
        RouteDoc.CodigoAutotransporte = value;
        this.RefreshModel(RouteDoc);
    }

    OnchangeRouteStatus = () => {
        const { RouteDoc } = this.props
        RouteDoc.IsActive = !RouteDoc.IsActive;
        this.RefreshModel(RouteDoc);
    }

    ChangeOrderDateInit = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.InitialDate = value;
        RouteDoc.FinalDate = value;
        this.RefreshModel(RouteDoc);
    }

    ChangeOrderDateFinal = (value) => {
        const { RouteDoc, } = this.props
        RouteDoc.FinalDate = value;
        this.RefreshModel(RouteDoc);


    }

    ValidateFinalDate = () => {
        const { RouteDoc, showAlert } = this.props
        if (RouteDoc.FinalDate < RouteDoc.InitialDate) {
            showAlert({ type: 'error', message: `LA FECHA FINAL NO PUEDE SER MENOR ` });
            RouteDoc.FinalDate = RouteDoc.InitialDate;
            this.RefreshModel(RouteDoc);
        }
    }


    //#endregion

    render() {
        const { InitDateSearch,
            FinalDateSearch, ChangeFinalDate,
            UnAssignedDocs, AddToRoute,
            RouteDoc, Drivers, Waypoints,
            Vehicles, SaveRoute, DeleteRoutePartner, 
            ChangeInitialDate, GetAllUnAssignedDocs } = this.props

        return (
            <div className='m-5'>
                <div id="create-Route-form">
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y">
                            <div className='row'>
                                <div className="col-lg-12 mb-4 order-0">
                                    <div className="card">
                                        <div className="d-flex align-items-end row">
                                            <div className="col-sm-12">
                                                <div className="card-body" >
                                                    <div style={{ height: '400px', }}>
                                                        <TryMap
                                                            waypoints={Waypoints}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className='row'>
                                <div className="col-md-6 col-lg-4 order-0 mb-4">
                                    <div className="card h-100">
                                        <div className="card-header d-flex align-items-center justify-content-between">
                                            <h5 className="card-title m-0 me-2">ENTREGAS PENDIENTES</h5>
                                        </div>
                                        <div className="card-body " >
                                            <div className='row'>
                                                <div className="form-group col">
                                                    <label className="Desde"><strong>Desde:&nbsp;&nbsp;</strong></label>
                                                    <input id="orderFechaInicioRelation"
                                                        className="form-control btn-outline-secondary listSerie" type="date"
                                                        placeholder="Fecha inicio" autoComplete="off"
                                                        value={InitDateSearch ?? ''}
                                                        onChange={(event) => ChangeInitialDate(event.target.value)}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                GetAllUnAssignedDocs();
                                                            }
                                                        }}

                                                    />
                                                </div>
                                                <div className="form-group col">
                                                    <label className="Hasta"><strong> &nbsp;&nbsp;Hasta:&nbsp;&nbsp;</strong></label>
                                                    <input id="orderFechaFinRelation"
                                                        className="form-control btn-outline-secondary listSerie " type="date"
                                                        placeholder="Fecha min" autoComplete="off"
                                                        value={FinalDateSearch ?? ''}
                                                        onChange={(event) => ChangeFinalDate(event.target.value)}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                GetAllUnAssignedDocs();

                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                                                <ul className="p-0 m-0">
                                                    <li className="d-flex mb-4 pb-1">
                                                        <div className="avatar flex-shrink-0 mr-2 ml-2 mt-2" style={{ maxHeight: "25px", maxWidth: "25px" }}>
                                                            {/* <span className="sidebar-icon">
                                                                <img src={require('../../images/ico/trasladosEntry.png')} alt="" className="ico-sidebar" />
                                                            </span> */}
                                                        </div>
                                                    </li>
                                                    {UnAssignedDocs && UnAssignedDocs.length > 0 &&
                                                        UnAssignedDocs.map((order, index) => {
                                                            return (
                                                                <table>
                                                                    <tbody>
                                                                        <tr key={index}>
                                                                            <td className='justify-content-start'>
                                                                                <button className="btn btn-sm" type="button">
                                                                                <i className="fa fa-info-circle"></i>
                                                                                </button>
                                                                            </td>
                                                                            <td className='justify-content-start col-md-8'>
                                                                                <div >
                                                                                    <small className="text-muted d-block mb-1">DocNum:{order.DocNum}</small>
                                                                                    <h6 className=" mb-0">Cliente: {order.CardName}. CardCode: {order.CardCode}  </h6>
                                                                                </div>
                                                                            </td>
                                                                            <td className='justify-content-start col-md-2'>
                                                                                <div>
                                                                                <button className="btn btn-sm col-md-2" type="button" onClick={() => AddToRoute(order)} >
                                                                                        <i className="fa fa-plus"></i>
                                                                                    </button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            );
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 mb-4 order-2">
                                    <div className="card">
                                        <div className="d-flex align-items-end row">
                                            <div className="col-sm-12">
                                                <div className="card-body">
                                                    <h5 className="card-title text-primary">Crear Ruta </h5>
                                                    <div className='row'>
                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1">
                                                                <strong>Código de la ruta: </strong>
                                                                <i className="fa fa-question-circle" onClick={() => this.LaunchMsj('routeCode')}></i>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Código"
                                                                disabled={true}
                                                                value={RouteDoc ? RouteDoc.Code : ''}
                                                                onChange={(event) => this.OnchangeRouteCode(event.target.value)}
                                                            />

                                                        </div>
                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1"><strong>Nombre de la ruta</strong></label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder='Nombre ruta'
                                                                value={RouteDoc ? RouteDoc.Name : ''}
                                                                onChange={(event) => this.OnchangeRouteName(event.target.value)}
                                                            />

                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className="form-group col-md-6">
                                                            <label className="Desde"><strong>Fecha de la entrega:&nbsp;&nbsp;</strong></label>
                                                            <input id="orderFechaInicioRelation"
                                                                className="form-control btn-outline-secondary listSerie " type="date"
                                                                placeholder="Fecha min" autoComplete="off"
                                                                value={RouteDoc ? RouteDoc.InitialDate : ''}
                                                                onChange={(event) => this.ChangeOrderDateInit(event.target.value)}
                                                            />
                                                        </div>
                                                        {/* <div class="form-group col">
                                                            <label className="Hasta"><strong> &nbsp;&nbsp;Dia limite:&nbsp;&nbsp;</strong></label>
                                                            <input id="orderFechaFinRelation"
                                                                className="form-control btn-outline-secondary listSerie " type="date"
                                                                placeholder="Fecha min" autoComplete="off"
                                                                value={RouteDoc ? RouteDoc.FinalDate : ''}
                                                                onBlur={() => this.ValidateFinalDate()}
                                                                onChange={(event) => this.ChangeOrderDateFinal(event.target.value)}
                                                            />
                                                        </div> */}
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-sm-8'>
                                                            <label for="exampleInputEmail1"><strong>Chofer</strong></label>
                                                            <select id="toggleCostumer"
                                                                className="form-control"
                                                                onChange={(event) => this.OnchangeDriver(event.target.value)}
                                                                value={RouteDoc ? RouteDoc.AuxIndexDriver : ''}
                                                            >
                                                                <option>Seleccione el chofer responsable</option>
                                                                {Drivers && Drivers.map((driver, index) => {
                                                                    return (
                                                                        <option key={index} value={index}>
                                                                            {driver?.NombreFigura ?? ""}.  -  {changeTipoFigura((driver?.TipoFigura ?? "").trim() ?? '')}
                                                                        </option>
                                                                    );
                                                                })}

                                                            </select>
                                                        </div>

                                                        <div className='col-sm-3'>
                                                            {/* <label for="exampleInputEmail1">Buscar por nombre </label>
                                                                <input
                                                                    type="text"
                                                                    class="form-control"
                                                                    id="exampleInputEmail1"
                                                                    aria-describedby="emailHelp"
                                                                    placeholder="Nombre"
                                                                    value={routeDoc && routeDoc.name != '' ? routeDoc.name : ''}
                                                                    onChange={(event) => SetData(event.target.value, 2)}
                                                                /> */}
                                                        </div>
                                                        <div className='col-sm-1'>
                                                            {/* <label for="exampleInputEmail1" style={{ color: 'white' }}>.</label>
                                                                <button
                                                                    className="btn"
                                                                    type="button"
                                                                    style={{ backgroundColor: config.palette.primaryColor }}
                                                                    // onClick={setCustomerFunction}
                                                                >
                                                                    <span class="fa fa-search" style={{ color: 'white' }}></span>
                                                                </button> */}
                                                        </div>

                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-sm-8'>
                                                            <label for="exampleInputEmail1"><strong>Vehículo</strong></label>
                                                            <select id="toggleCostumer"
                                                                className="form-control"
                                                                onChange={(event) => this.OnchangeVehicle(event.target.value)}
                                                                value={RouteDoc ? RouteDoc.CodigoAutotransporte : ''}
                                                            >
                                                                <option>Seleccione el chofer responsable</option>
                                                                {Vehicles && Vehicles.map((vehicle, index) => {
                                                                    return (
                                                                        <option key={index} value={vehicle.CodigoAutotransporte}>
                                                                            {vehicle.TipodeUnidad} - {vehicle.ConfigVehicular}. Matricula: {vehicle.PlacaVM}
                                                                        </option>
                                                                    );
                                                                })}

                                                            </select>
                                                        </div>

                                                        <div className='col-sm-3'>
                                                        </div>
                                                        <div className='col-sm-1'>
                                                        </div>

                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1"><strong>Comentario</strong></label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Comentario"
                                                                value={RouteDoc.Description ? RouteDoc.Description : ''}
                                                                onChange={(event) => this.OnchangeRouteDescription(event.target.value)}
                                                            />


                                                        </div>

                                                        <div className='col-sm-1'>
                                                            <div className='d-flex justify-content-center'>
                                                                <label className='' for="exampleInputEmail1"><strong>Activa</strong></label>
                                                            </div>
                                                            <div className='d-flex justify-content-center w-100 h-50'>
                                                            <input
                                                                    style={{scale: '2'}}
                                                                    type="checkbox"
                                                                    checked={RouteDoc.IsActive}
                                                                    onClick={() => this.OnchangeRouteStatus()}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <h5 className="card-title text-primary mt-2 mb-2">Ordenes en ruta </h5>
                                                    <div className='row'>
                                                        <div className='col-sm-12'>
                                                            <div style={{ minHeight: '30vh', maxHeight: '30vh', overflowY: 'auto' }}>
                                                                <ul className="p-0 m-0">

                                                                    {RouteDoc && RouteDoc.DocsLines && RouteDoc.DocsLines.length > 0 &&
                                                                        RouteDoc.DocsLines.map((docLine, index) => {
                                                                            return (
                                                                                <li className="d-flex mb-4 pb-1">
                                                                                    <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                                                                        <div className="me-2">
                                                                                            <small className="text-muted d-block mb-1">{`Latitud: ${docLine.U_FMB_GPSLatS}  Longitud: ${docLine.U_FMB_GPSLonS}`}</small>
                                                                                            <h6 className="mb-0">DocNum: {docLine.DocNum} Cliente: {docLine.CardCode}</h6>
                                                                                        </div>
                                                                                        <div className="user-progress d-flex align-items-center gap-1">
                                                                                            <button
                                                                                                className="btn btn-sm"
                                                                                                type="button"
                                                                                                onClick={() => DeleteRoutePartner(index)}

                                                                                            >
                                                                                                <i className="fa fa-trash-o"></i>
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </li>
                                                                            );
                                                                        })

                                                                    }
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className='row'>
                                                        <div className="d-flex justify-content-end bd-highlight mb-3">
                                                            <button
                                                                type="button"
                                                                className="btn btn-success"
                                                                onClick={SaveRoute}
                                                            >Agregar Ruta</button>
                                                        </div>

                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row' style={{ height: '10vh' }}>
                            </div>
                        </div>
                        <div className="content-backdrop fade"></div>
                    </div>
                </div>
            </div>
        )
    }


    LaunchMsj = (key) => {
        const {  showAlert } = this.props
        switch (key) {
            case 'routeCode':
                showAlert({ type: 'info', message: `NOSOTROS GENERAREMOS EL CODIGO DE TODAS LAS RUTAS DE ENTREGA. EL CODIGO MOSTRADO ES UN ESTIMADO, PODRÍA CAMBIAR`, timeOut: 5000 });
                break;
        
            default:
                break;
        }
       
    }


}
export default CreateRoute